import React from "react";
import { message } from "antd";

const setUserData = (type = "success", text = "") => {
  if (type === "success") {
    message.success(text);
  }
  if (type === "error") {
    message.error(text);
  }
  if (type === "warning") {
    message.warning(text);
  }
  if (type === "info") {
    message.info(text);
  }
  if (type === "loading") {
    message.loading(text);
  }
};

export default setUserData;
